unit share.system.classes;

interface

uses
  System.Generics.Collections;

type
  TSysAutoMailView  = class   //Auto email view
    private
      FAutoMail_Auto : Integer;
      FSlnCode : String;
      FReportSystem  : Integer;
      FCompany : String;
      FPeriodNo : Integer;
      FPeriodType : Integer;
      FLastDate : TDate;
      FNextDate : TDate;
      FChangeDate : TDate;
      FUserNotice : Boolean;
      FUserEmail : Boolean;
      FReportDesc : string;
      FPeriodTypeDesc : string;
      FCRName : string;
    published
      property AutoMail_Auto : Integer read FAutoMail_Auto write FAutoMail_Auto;
      property SLnCode : String read FSLNCODE write FSLNCODE;
      property ReportSystem  : Integer read FREPORTSYSTEM write FREPORTSYSTEM;
      property Company : String read FCOMPANY write FCOMPANY;
      property PeriodNo : Integer read FPERIODNO write FPERIODNO;
      property PeriodType : Integer read FPERIODTYPE write FPERIODTYPE;
      property LastDate : TDate read FLASTDATE write FLASTDATE;
      property NextDate : TDate read FNEXTDATE write FNEXTDATE;
      property ChangeDate : TDate read FCHANGEDATE write FCHANGEDATE;
      property UserNotice : Boolean read FUSERNOTICE write FUSERNOTICE;
      property UserEmail : Boolean read FUSEREMAIL write FUSEREMAIL;
      property ReportDesc : String read FReportDesc write FReportDesc;
      property PeriodTypeDesc : String read FPeriodTypeDesc write FPeriodTypeDesc;
      property CRName : String read Fcrname write Fcrname;
  end;

  TSysAutoMailInsert = class
    Private
      FSLnCode : String;
      FUserCode : string;
      FReportSystem : Integer;
      FCompany : string;
      FPeriodNo :Integer;
      FPeriodType : Integer;
      FLastDate: TDate;
      FNextDate : TDate;
      FChangeDate : TDate;
      FUserNotic : Boolean;
      FUserEmail : Boolean;
    published
      Property SLnCode :  String read FSLnCode write FSLnCode;
      property UserCode : String read FUserCode write FUserCode;
      property ReportSystem  : Integer read FReportSystem write FReportSystem;
      property Company : String read FCompany write FCompany;
      property PeriodNo : Integer read FPeriodNo write FPeriodNo;
      property PeriodType : Integer read FPeriodType write FPeriodType;
      property LastDate : TDate read FLastDate write FLastDate;
      property NextDate : TDate read FNextDate write FNextDate;
      property ChangeDate : TDate read FChangeDate write FChangeDate;
      property UserNotice : Boolean read FUserNotic write FUserNotic;
      property UserEmail : Boolean read FUserEmail write FUserEmail;
  end;

  TSysAutoMailEdit = class
    Private
      FAutoMail_Auto : Integer;
      FUserCode : string;
      FReportSystem : Integer;
      FCompany : string;
      FPeriodNo :Integer;
      FPeriodType : Integer;
      FLastDate: TDate;
      FNextDate : TDate;
      FChangeDate : TDate;
      FUserNotic : Boolean;
      FUserEmail : Boolean;
    published
      property AutoMail_Auto : Integer read FAutoMail_Auto write FAutoMail_Auto;
      property UserCode : String read FUserCode write FUserCode;
      property ReportSystem  : Integer read FReportSystem write FReportSystem;
      property Company : String read FCompany write FCompany;
      property PeriodNo : Integer read FPeriodNo write FPeriodNo;
      property PeriodType : Integer read FPeriodType write FPeriodType;
      property LastDate : TDate read FLastDate write FLastDate;
      property NextDate : TDate read FNextDate write FNextDate;
      property ChangeDate : TDate read FChangeDate write FChangeDate;
      property UserNotice : Boolean read FUserNotic write FUserNotic;
      property UserEmail : Boolean read FUserEmail write FUserEmail;
  end;

  TReportigSystem = class
    Private
      FAutoNumber : integer;
      FDescription : String;
    Published
      property AutoNumber : Integer read FAutoNumber write FAutoNumber;
      property Description : String read FDescription write FDescription;
  end;

  TPeriodType = class
    Private
      FPeriodType_Auto : integer;
      FDescription : String;
    Published
      property PeriodType_Auto : Integer read FPeriodType_Auto write FPeriodType_Auto;
      property Description : String read FDescription write FDescription;
  end;

  TFleetTypes = class
    private
      FAutoNo : integer;
      FDescription : string;

    published
      property AutoNo : integer read FAutoNo write FAutoNo;
      property Description : string read Fdescription write FDescription;

  end;

  TSysCostGroupsView = class
    private
      FCode : integer;
      FDescription :  String;
      FSuspended :  Boolean;
    Published
      property Code : Integer read FCode write FCode;
      property Description : String read FDescription write FDescription;
      property Suspended : Boolean read FSuspended write FSuspended;
  end;

  TSysCostGroupDetailsView = class
    private
      FCostGroupMo : Integer;
      FFleetType : Integer;
      FValueType : Integer;
      FSystemType : Integer;
      FGLCode : String;
      Fcostgroupsdetail_Auto : Integer;
    published
      property CostGroupMo : Integer read FCostGroupMo write FCostGroupMo;
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;
      property costgroupsdetail_Auto : Integer read Fcostgroupsdetail_Auto write Fcostgroupsdetail_Auto;

  end;

  TSysCostGroupDetailsInsert = class
    private
      FCostGroupMo : Integer;
      FFleetType : integer;
      FValuetype : Integer;
      FSystemType : Integer;
      FGLCode : String;
    Published
      property CostGroupMo : Integer read FCostGroupMo write FCostGroupMo;
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;

  end;

  TSysCostGroupDetailsEdit = class
    private
      FCostGroup_Auto : Integer;
      FCostGroupMo : Integer;
      FFleetType : integer;
      FValuetype : Integer;
      FSystemType : Integer;
      FGLCode : String;
    Published
      property CostGroup_Auto : Integer read FCostGroup_Auto write FCostGroup_Auto;
      property CostGroupMo : Integer read FCostGroupMo write FCostGroupMo;
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;

  end;

  TsysFinancialPeriodsSetupView = class
    private
      FSystemType : String;
      FOpenPeriod : Integer;
      FClosePeriod : Integer;
      FRollon : Boolean;
      FDescription : String;
      FCloseLast : Boolean;
      FMonthEndDone : Boolean;
      FMonthEndDate : TDateTime;
      FMonthEndUser : String;
      FLastMonthEnd : Integer;
      FCutOffDate : TDate;
      FCurrentMonthEnd : Integer;
      FDoCutOff : Boolean;
    published
      property SystemType : String read FSystemType write FSystemtype;
      property OpenPeriod : Integer read FOpenPeriod write FOpenPeriod;
      property ClosePeriod : Integer read FClosePeriod write FClosePeriod;
      property Rollon : Boolean read FRollon write FRollon;
      property Description : String read FDescription write FDescription;
      property CloseLast : Boolean read FCloseLast write FCloseLast;
      property MonthEndDone : Boolean read FMonthEndDone write FMonthEndDone;
      property MonthEndDate : TDateTime read FMonthEndDate write FMonthEndDate;
      property MonthEndUser : String read FMonthEndUser write FMonthEndUser;
      property LastMonthEnd : Integer read FLastMonthEnd write FLastMonthEnd;
      property CutOffDate : TDate read FCutOffDate write FCutOffDate;
      property CurrentMonthEnd : Integer read FCurrentMonthEnd write FCurrentMonthEnd;
      property DoCutOff : Boolean read FDoCutOff write FDoCutOff;

  end;

  TsysFinancialperiodCutOffDateEdit = class
    private
      FSystem : String;
      FRollon : Boolean;
      FCloseLast : Boolean;
      FMonthEndDone : Boolean;
      FDoCutOff : boolean;
    published
      property System : String read FSystem write FSystem;
      property Rollon : Boolean read FRollon write FRollon;
      property CloseLast : Boolean read FCloseLast write FCloseLast;
      property MonthEndDone : Boolean read FMonthEndDone write FMonthEndDone;
      property DoCutOff : Boolean read FDoCutOff write FDoCutOff;

  end;

  TValueTypes = class
    private
      FAutoNo : Integer;
      FDescription : String;

    Published
      property AutoNo : Integer read FAutoNo write FAutoNo;
      property Description : String read FDescription write FDescription;
  end;

  TSystemTypes = class
    private
      FSystemNO : Integer;
      FDescription : String;
    Published
      property SystemNO : Integer read FSystemNO write FSystemNO;
      property Description : String read FDescription write FDescription;
  end;

  TGLAcounts = class
    private
      FGLCode : String;
      FGLDescription : String;
    Published
      property GLCode : String read FGLCode write FGLCode;
      property GLDescription : String read FGLDescription write FGLDescription;
  end;

  TCostGroups = class
    private
      FCode : Integer;
      FDescripiton : String;
      FSuspended : String;
    published
      Property Code : Integer read FCode write Fcode;
      Property Description : String read FDescripiton write FDescripiton;
      Property Suspended : String read FSuspended Write FSuspended;
  end;

  TSysCostGroupDetails_PK = class
    private
      FFleetType : Integer;
      FValueType : Integer;
      FSystemType : Integer;
      FGLCode : String;
    published
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;

  end;

  TCompanyInfo = class
    private
      FCompanyCode : Integer;
      FCOMPANYNAME : String;
      FADDRESS1,
      FADDRESS2,
      FADDRESS3,
      FADDRESS4,
      FADDRESSCODE,
      FCOMPANYTEL,
      FCOMPANYFAX,
      FCOMPANYREG,
      FCOMPANYVAT,
      FLOGOPATH : String;
      FUSEDIFFCOMP : Boolean;
      FBANKDETAILS1,
      FBANKDETAILS2,
      FBANKDETAILS3,
      FBANKDETAILS4,
      FLOADCONPREFIX,
      FLOADCONTYPE : String;
      FSSUNIQUECLIENTDOCKET,
      FSSCLOADCONLOADDATE,
      FSSCLOADCONOFFLOADDATE,
      FSSCLOADCONRECEIVEDATE,
      FSSCLOADCONCOMPLETEDATE : Boolean;
      FSSCLOADCONLOADTIME,
      FSSCLOADCONOFFLOADTIME,
      FSSCLOADCONRECEIVETIME,
      FSSCLOADCONCOMPLETETIME,
      FSSCLOADCONLOADDATEC,
      FSSCLOADCONOFFLOADDATEC,
      FSSCLOADCONRECEIVEDATEC,
      FSSCLOADCONCOMPLETEDATEC,
      FSSCLOADCONLOADTIMEC,
      FSSCLOADCONOFFLOADTIMEC,
      FSSCLOADCONRECEIVETIMEC,
      FSSCLOADCONCOMPLETETIMEC : Integer;
      FUSEFINLINKSYSTEM : Boolean;
      FFINLINKSYSTEM : Integer;
      FAUTOMAILSYSTEM : Boolean;
      //FFINDBSETUP : TMemoryStream;
      FMAILSERVER : String;
      FMAILSERVERPORT : Integer;
      FMAILSERVERAUTH : Boolean;
      FMAILSERVERUSER,
      FMAILSERVERPASS : String;
      FMAILSERVERSSL : Boolean;
      FMAILSERVERPROTOCOL : Integer;
      FMAILSERVERSIGNATURE,
      FMAILSERVERENCRYPTION : Boolean;
      FMAILSERVERENCODING : String;
      FDCLPERC : Real;
      FBANKSTATEMENT : Boolean;
      FSSFLOADCONLOADDATEC,
      FSSFLOADCONOFFLOADDATEC,
      FSSFLOADCONRECEIVEDATEC,
      FSSFLOADCONCOMPLETEDATEC,
      FSSFLOADCONLOADTIMEC,
      FSSFLOADCONOFFLOADTIMEC,
      FSSFLOADCONRECEIVETIMEC,
      FSSFLOADCONCOMPLETETIMEC : Integer;
      FFORCEDIESELDRIVER,
      FFORCELOADDRIVER : Boolean;
      FDEFDIESELORDERS,
      FDEFLOADORDERS : Integer;
      FINVOICESYSTEM : Boolean;
      FBTBRANCHCODE,
      FBTACCOUNTNO,
      FTRIPSHEETTYPE : String;
      FLOADCUSTOMERS : Boolean;
      FFINLINKSYSTEMCOUNT : Integer;
      FFIN1NAME,
      FFIN2NAME : String;
      FUSEDOCKETNOINVNO,
      FUSEADDINFONONCON : Boolean;
      FSTATEMENTTYPE : String;
      FSTOCKSTDPERC,
      FSTOCKDEDPERC,
      FSTOCKSPEPERC : Real;
      FEMPADDCOMDESC : String;
      FNONCONDISPLAYFUEL : Boolean;
      FADD1DESC,
      FADD2DESC,
      FADD3DESC,
      FADD4DESC,
      FADD5DESC,
      FADD6DESC,
      FADD7DESC,
      FPOSTALADDRESS1,
      FPOSTALADDRESS2,
      FPOSTALADDRESS3,
      FPOSTALADDRESS4,
      FPOSTALCODE : String;
      FUSEMULTICOMPANYINVOICE,
      FMISCINVLOADS,
      FPRINTTOTALSSEND  : Boolean;
      FWEBSERVERADDRESS : String;
      FWEBSERVERPORT : Integer;
      FWEBSERVERUSER,
      FWEBSERVERPASSWORD,
      FWEBSERVERSCANAPI,
      FDBSERVERADDRESS : String;
      FDBSERVERPORT : Integer;
      FINTERNALADDRESS : String;
      FINTERNALPORT : Integer;
      FWEBSERVERDB,
      FWEBSERVERDBUSER,
      FWEBSERVERDBPASS : String;
      FUNIQUEORDER,
      FUNIQUEWAYBILLS,
      FUNIQUEWASHBAYDOCKET : Boolean;
      FIMPORTPERIOD,
      FIMPORTBATCH : Integer;
      FPRINTLOADSAVE,
      FNOFUTUREINVDATE,
      FUNIQUESHORTDESC : Boolean;
      FCUSTMISCTYPE,
      FSUPPMISCTYPE,
      FJOBCARDPREFIX,
      FREQUESTPREFIX,
      FORDERSPREFIX : String;
      FMISCGLFORCE,
      FSUBUNINVSHOW : Boolean;
      Femployeedemerit,
      Fvehicledemerit : Integer;
      Fmonitorvehiclechanges,
      Fmonitordieselupfrontcl,
      Fmonitorloadssub,
      Fmonitorcancelloads : Boolean;
      Fcheckdieselordersdays : Integer;
      FJobCompType,
      Ffinesbrnno,
      Ffinesidno : String;
      Fsmsdiesel : Boolean;
      Fsmsdieselurl,
      Fsmsdieseluser,
      Fsmsdieselpassword,
      FINSTRUCTORDER : String;
      Fwashbayinvloads,
      Fsubsoverrite : Boolean;
      Fcommissiontype : integer;
      Fallowdieselproforma,
      Fforcescandocs : Boolean;
      FBANKDETAIL5,
      FBANKDETAIL6,
      FBANKDETAIL7,
      FBANKDETAIL8 : String;
      ////////////////////Flogo : ;
      Fautocanceldieselorders : boolean;
      Fautocanceldieselordersdays : Integer;
      Fsendloadconsprocess,
      Floadcoscutoffdate,
      Fdieselcutoffdate,
      Fhidecanceloadsplanning,
      Fincrementdocketno,
      Flinklastdriver,
      Fplanningshortdesc,
      Fallowreprint,
      Fremovesubinvdocs,
      Floadsmustreceived : boolean;
      Ffnbcontractid,
      Ffnbclientid : String;
      Ffnbdeblistcount,
      Ffnbcredlistcount : Integer;
      Ffnblastdebdate,
      Ffnblastcreddate : TDate;
      Ffnblastdebamount,
      Ffnblastcredamount : Real;
      Ffnbclienttype : Integer;
      Flinkloadsvat,
      Fmarkmultiloadready,
      Fbulkdieselinvoices,
      Fclearbulkinvoices,
      Fgetsageonlinebalance : Boolean;
      Fusesageonlinebalancefordiesel : Real;
      Fapiserverurl,
      Fapiusername,
      Fapipassword,
      Fapikey : String;
      Ffuelconsumptionfullfill,
      Fusenewscan : Boolean;
      Fbasescanfolder,
      Fftpserver : String;
      Fftpport : SmallInt;
      Fftpuser,
      Fftppassword : String;
      Fmulticontroller : Boolean;
      Flastshiftno : Integer;
      Fdieselnonretail : Boolean;
      Femailaddress : String;
      Fjobnullqty,
      Fjoborder : boolean;
      Fjobcardtype : String;
      Fmaintforcegl : Boolean;
      Fcompemail,
      Ferrormails : String;

    published

    property  CompanyCode : Integer read FCompanyCode Write FCompanyCode;
    property  COMPANYNAME : String read FCOMPANYNAME Write FCOMPANYNAME;
    property  ADDRESS1 : String read FADDRESS1 Write FADDRESS1;
    property  ADDRESS2 : String read FADDRESS2 Write FADDRESS2;
    property  ADDRESS3 : String read FADDRESS3 Write FADDRESS3;
    property  ADDRESS4 : String read FADDRESS4 Write FADDRESS4;
    property  ADDRESSCODE : String read FADDRESSCODE Write FADDRESSCODE;
    property  COMPANYTEL : String read FCOMPANYTEL Write FCOMPANYTEL;
    property  COMPANYFAX : String read FCOMPANYFAX Write FCOMPANYFAX;
    property  COMPANYREG : String read FCOMPANYREG Write FCOMPANYREG;
    property  COMPANYVAT : String read FCOMPANYVAT Write FCOMPANYVAT;
    property  LOGOPATH : String read FLOGOPATH Write FLOGOPATH;
    property  USEDIFFCOMP : Boolean read FUSEDIFFCOMP Write FUSEDIFFCOMP;
    property  BANKDETAILS1 : String read FBANKDETAILS1 Write FBANKDETAILS1;
    property  BANKDETAILS2 : String read FBANKDETAILS2 Write FBANKDETAILS2;
    property  BANKDETAILS3 : String read FBANKDETAILS3 Write FBANKDETAILS3;
    property  BANKDETAILS4 : String read FBANKDETAILS4 Write FBANKDETAILS4;
    property  LOADCONPREFIX : String read FLOADCONPREFIX Write FLOADCONPREFIX;
    property  LOADCONTYPE : String read FLOADCONTYPE Write FLOADCONTYPE;
    property  SSUNIQUEClientDocket : Boolean read FSSUNIQUEClientDocket Write FSSUNIQUEClientDocket;
    property  SSCLOADCONLOADDATE : Boolean read FSSCLOADCONLOADDATE Write FSSCLOADCONLOADDATE;
    property  SSCLOADCONOFFLOADDATE : Boolean read FSSCLOADCONOFFLOADDATE Write FSSCLOADCONOFFLOADDATE;
    property  SSCLOADCONRECEIVEDATE : Boolean read FSSCLOADCONRECEIVEDATE Write FSSCLOADCONRECEIVEDATE;
    property  SSCLOADCONCOMPLETEDATE : Boolean read FSSCLOADCONCOMPLETEDATE Write FSSCLOADCONCOMPLETEDATE;
    property  SSCLOADCONLOADTIME : Integer read FSSCLOADCONLOADTIME Write FSSCLOADCONLOADTIME;
    property  SSCLOADCONOFFLOADTIME : Integer read FSSCLOADCONOFFLOADTIME Write FSSCLOADCONOFFLOADTIME;
    property  SSCLOADCONRECEIVETIME : Integer read FSSCLOADCONRECEIVETIME Write FSSCLOADCONRECEIVETIME;
    property  SSCLOADCONCOMPLETETIME : Integer read FSSCLOADCONCOMPLETETIME Write FSSCLOADCONCOMPLETETIME ;
    property  SSCLOADCONLOADDATEC : Integer read FSSCLOADCONLOADDATEC Write FSSCLOADCONLOADDATEC;
    property  SSCLOADCONOFFLOADDATEC : Integer read FSSCLOADCONOFFLOADDATEC Write FSSCLOADCONOFFLOADDATEC;
    property  SSCLOADCONRECEIVEDATEC : Integer read FSSCLOADCONRECEIVEDATEC Write FSSCLOADCONRECEIVEDATEC;
    property  SSCLOADCONCOMPLETEDATEC : Integer read FSSCLOADCONCOMPLETEDATEC Write FSSCLOADCONCOMPLETEDATEC;
    property  SSCLOADCONLOADTIMEC : Integer read FSSCLOADCONLOADTIMEC Write FSSCLOADCONLOADTIMEC;
    property  SSCLOADCONOFFLOADTIMEC : Integer read FSSCLOADCONOFFLOADTIMEC Write FSSCLOADCONOFFLOADTIMEC;
    property  SSCLOADCONRECEIVETIMEC : Integer read FSSCLOADCONRECEIVETIMEC Write FSSCLOADCONRECEIVETIMEC;
    property  SSCLOADCONCOMPLETETIMEC : Integer read FSSCLOADCONCOMPLETETIMEC Write FSSCLOADCONCOMPLETETIMEC;
    property  USEFINLINKSYSTEM : Boolean READ FUSEFINLINKSYSTEM WRITE FUSEFINLINKSYSTEM;
    property  FINLINKSYSTEM : Integer READ FFINLINKSYSTEM WRITE FFINLINKSYSTEM;
    property  AUTOMAILSYSTEM : Boolean READ FAUTOMAILSYSTEM WRITE FAUTOMAILSYSTEM;
    //property  FINDBSETUP : TMemoryStream
    property  MAILSERVER : String READ FMAILSERVER WRITE FMAILSERVER;
    property  MAILSERVERPORT : Integer READ FMAILSERVERPORT WRITE FMAILSERVERPORT;
    property  MAILSERVERAUTH : Boolean READ FMAILSERVERAUTH WRITE FMAILSERVERAUTH;
    property  MAILSERVERUSER : String READ FMAILSERVERUSER WRITE FMAILSERVERUSER;
    property  MAILSERVERPASS : String READ FMAILSERVERPASS WRITE FMAILSERVERPASS;
    property  MAILSERVERSSL : Boolean READ FMAILSERVERSSL WRITE FMAILSERVERSSL;
    property  MAILSERVERPROTOCOL : Integer READ FMAILSERVERPROTOCOL WRITE FMAILSERVERPROTOCOL;
    property  MAILSERVERSIGNATURE :  Boolean Read FMAILSERVERSIGNATURE Write FMAILSERVERSIGNATURE;
    property  MAILSERVERENCRYPTION : Boolean Read FMAILSERVERENCRYPTION Write FMAILSERVERENCRYPTION;
    property  MAILSERVERENCODING : String Read FMAILSERVERENCODING Write FMAILSERVERENCODING;
    property  DCLPERC : Real Read FDCLPERC Write FDCLPERC;
    property  BANKSTATEMENT : Boolean Read FBANKSTATEMENT Write FBANKSTATEMENT;
    property  SSFLOADCONLOADDATEC : Integer Read FSSFLOADCONLOADDATEC Write FSSFLOADCONLOADDATEC;
    property  SSFLOADCONOFFLOADDATEC : integer Read FSSFLOADCONOFFLOADDATEC Write FSSFLOADCONOFFLOADDATEC;
    property  SSFLOADCONRECEIVEDATEC : Integer Read FSSFLOADCONRECEIVEDATEC Write FSSFLOADCONRECEIVEDATEC;
    property  SSFLOADCONCOMPLETEDATEC : Integer Read FSSFLOADCONCOMPLETEDATEC Write FSSFLOADCONCOMPLETEDATEC;
    property  SSFLOADCONLOADTIMEC : Integer Read FSSFLOADCONLOADTIMEC Write FSSFLOADCONLOADTIMEC;
    property  SSFLOADCONOFFLOADTIMEC : Integer Read FSSFLOADCONOFFLOADTIMEC Write FSSFLOADCONOFFLOADTIMEC;
    property  SSFLOADCONRECEIVETIMEC : Integer Read FSSFLOADCONRECEIVETIMEC Write FSSFLOADCONRECEIVETIMEC;
    property  SSFLOADCONCOMPLETETIMEC : Integer Read FSSFLOADCONCOMPLETETIMEC Write FSSFLOADCONCOMPLETETIMEC;
    property  FORCEDIESELDRIVER : Boolean Read FFORCEDIESELDRIVER Write FFORCEDIESELDRIVER;
    property  FORCELOADDRIVER : Boolean Read  FFORCELOADDRIVER Write FFORCELOADDRIVER;
    property  DEFDIESELORDERS : Integer Read FDEFDIESELORDERS Write FDEFDIESELORDERS;
    property  DEFLOADORDERS : Integer Read FDEFLOADORDERS Write FDEFLOADORDERS;
    property  INVOICESYSTEM : Boolean Read FINVOICESYSTEM Write FINVOICESYSTEM;
    property  BTBRANCHCODE : String Read FBTBRANCHCODE Write FBTBRANCHCODE;
    property  BTACCOUNTNO : String Read FBTACCOUNTNO Write FBTACCOUNTNO;
    property  TRIPSHEETTYPE : String Read FTRIPSHEETTYPE Write FTRIPSHEETTYPE;
    property  LOADCUSTOMERS : Boolean Read FLOADCUSTOMERS Write FLOADCUSTOMERS;
    property  FINLINKSYSTEMCOUNT : Integer Read FFINLINKSYSTEMCOUNT Write FFINLINKSYSTEMCOUNT;
    property  FIN1NAME : String Read FFIN1NAME Write FFIN1NAME;
    property  FIN2NAME : String Read FFIN2NAME Write FFIN2NAME;
    property  USEDOCKETNOINVNO : Boolean Read FUSEDOCKETNOINVNO Write FUSEDOCKETNOINVNO;
    property  USEADDINFONONCON : Boolean Read FUSEADDINFONONCON Write FUSEADDINFONONCON;
    property  STATEMENTTYPE : String Read FSTATEMENTTYPE Write FSTATEMENTTYPE;
    property  STOCKSTDPERC : Real Read FSTOCKSTDPERC Write FSTOCKSTDPERC;
    property  STOCKDEDPERC : Real Read FSTOCKDEDPERC Write FSTOCKDEDPERC;
    property  STOCKSPEPERC : Real Read FSTOCKSPEPERC Write FSTOCKSPEPERC;
    property  EMPADDCOMDESC : String Read FEMPADDCOMDESC Write FEMPADDCOMDESC;
    property  NONCONDISPLAYFUEL : Boolean Read FNONCONDISPLAYFUEL Write FNONCONDISPLAYFUEL;
    property  ADD1DESC : String Read FADD1DESC Write FADD1DESC;
    property  ADD2DESC : String Read FADD2DESC Write FADD2DESC;
    property  ADD3DESC : String Read FADD3DESC Write FADD3DESC;
    property  ADD4DESC : String Read FADD4DESC Write FADD4DESC;
    property  ADD5DESC : String Read FADD5DESC write FADD5DESC;
    property  ADD6DESC : String Read FADD6DESC Write FADD6DESC;
    property  ADD7DESC : String Read FADD7DESC Write FADD7DESC;
    property  POSTALADDRESS1 : String Read FPOSTALADDRESS1 Write FPOSTALADDRESS1;
    property  POSTALADDRESS2 : String Read FPOSTALADDRESS2 Write FPOSTALADDRESS2;
    property  POSTALADDRESS3 : String Read FPOSTALADDRESS3 Write FPOSTALADDRESS3;
    property  POSTALADDRESS4 : String Read FPOSTALADDRESS4 Write FPOSTALADDRESS4;
    property  POSTALCODE : String Read FPOSTALCODE Write FPOSTALCODE;
    property  USEMULTICOMPANYINVOICE : Boolean Read FUSEMULTICOMPANYINVOICE Write FUSEMULTICOMPANYINVOICE;
    property  MISCINVLOADS : Boolean Read FMISCINVLOADS Write FMISCINVLOADS;
    property  PRINTTOTALSSEND  : Boolean Read FPRINTTOTALSSEND Write FPRINTTOTALSSEND;
    property  WEBSERVERADDRESS : String Read FWEBSERVERADDRESS Write FWEBSERVERADDRESS;
    property  WEBSERVERPORT : Integer Read FWEBSERVERPORT Write FWEBSERVERPORT;
    property  WEBSERVERUSER : String Read FWEBSERVERUSER Write FWEBSERVERUSER;
    property  WEBSERVERPASSWORD : String Read FWEBSERVERPASSWORD Write FWEBSERVERPASSWORD;
    property  WEBSERVERSCANAPI : String Read FWEBSERVERSCANAPI write FWEBSERVERSCANAPI;
    property  DBSERVERADDRESS : String read FDBSERVERADDRESS Write FDBSERVERADDRESS;
    property  DBSERVERPORT : Integer Read FDBSERVERPORT Write FDBSERVERPORT;
    property  INTERNALADDRESS : String Read FINTERNALADDRESS Write FINTERNALADDRESS;
    property  INTERNALPORT : Integer Read FINTERNALPORT Write FINTERNALPORT;
    property  WEBSERVERDB : String Read FWEBSERVERDB Write FWEBSERVERDB;
    property  WEBSERVERDBUSER : String Read FWEBSERVERDBUSER Write FWEBSERVERDBUSER;
    property  WEBSERVERDBPASS : String Read FWEBSERVERDBPASS Write FWEBSERVERDBPASS;
    property  UNIQUEORDER : Boolean Read FUNIQUEORDER Write FUNIQUEORDER;
    property  UNIQUEWAYBILLS : Boolean Read FUNIQUEWAYBILLS Write FUNIQUEWAYBILLS;
    property  UNIQUEWASHBAYDOCKET : Boolean Read FUNIQUEWASHBAYDOCKET Write FUNIQUEWASHBAYDOCKET;
    property  IMPORTPERIOD : Integer Read FIMPORTPERIOD Write FIMPORTPERIOD;
    property  IMPORTBATCH : Integer Read FIMPORTBATCH Write FIMPORTBATCH;
    property  PRINTLOADSAVE : Boolean Read FPRINTLOADSAVE Write FPRINTLOADSAVE;
    property  NOFUTUREINVDATE : Boolean Read FNOFUTUREINVDATE Write FNOFUTUREINVDATE;
    property  UNIQUESHORTDESC : Boolean Read FUNIQUESHORTDESC Write FUNIQUESHORTDESC;
    property  CUSTMISCTYPE : String read FCUSTMISCTYPE write FCUSTMISCTYPE;
    property  SUPPMISCTYPE : String Read FSUPPMISCTYPE Write FSUPPMISCTYPE;
    property  JOBCARDPREFIX : String Read FJOBCARDPREFIX Write FJOBCARDPREFIX;
    property  REQUESTPREFIX : String Read FREQUESTPREFIX Write FREQUESTPREFIX;
    property  ORDERSPREFIX : String Read FORDERSPREFIX Write FORDERSPREFIX;
    property  MISCGLFORCE : Boolean Read FMISCGLFORCE Write FMISCGLFORCE;
    property  SUBUNINVSHOW : Boolean Read FSUBUNINVSHOW Write FSUBUNINVSHOW;
    property  employeedemerit : Integer Read Femployeedemerit Write Femployeedemerit;
    property  vehicledemerit : Integer Read Fvehicledemerit Write  Fvehicledemerit;
    property  monitorvehiclechanges : Boolean Read Fmonitorvehiclechanges Write Fmonitorvehiclechanges;
    property  monitordieselupfrontcl : Boolean Read Fmonitordieselupfrontcl write Fmonitordieselupfrontcl;
    property  monitorloadssub : Boolean read Fmonitorloadssub Write Fmonitorloadssub;
    property  monitorcancelloads : Boolean Read Fmonitorcancelloads Write Fmonitorcancelloads;
    property  checkdieselordersdays : Integer Read Fcheckdieselordersdays Write Fcheckdieselordersdays;
    property  JobCompType : String Read FJobCompType write FJobCompType;
    property  finesbrnno : String Read Ffinesbrnno Write Ffinesbrnno;
    property  finesidno : String Read Ffinesidno Write Ffinesidno;
    property  smsdiesel : Boolean Read Fsmsdiesel Write Fsmsdiesel;
    property  smsdieselurl : string Read Fsmsdieselurl Write Fsmsdieselurl;
    property  smsdieseluser : String Read Fsmsdieseluser Write Fsmsdieseluser;
    property  smsdieselpassword : String Read Fsmsdieselpassword Write Fsmsdieselpassword;
    property  INSTRUCTORDER : String Read FINSTRUCTORDER Write FINSTRUCTORDER;
    property  washbayinvloads : Boolean Read Fwashbayinvloads Write Fwashbayinvloads;
    property  subsoverrite : Boolean read Fsubsoverrite Write Fsubsoverrite;
    property  commissiontype : integer Read Fcommissiontype Write Fcommissiontype;
    property  allowdieselproforma : Boolean Read Fallowdieselproforma Write Fallowdieselproforma;
    property  forcescandocs : Boolean Read Fforcescandocs Write Fforcescandocs;
    property  BANKDETAIL5 : String Read FBANKDETAIL5 Write FBANKDETAIL5;
    property  BANKDETAIL6 : String Read FBANKDETAIL6 Write FBANKDETAIL6;
    property  BANKDETAIL7 : String Read FBANKDETAIL7 Write FBANKDETAIL7;
    property  BANKDETAIL8 : String Read FBANKDETAIL8 Write FBANKDETAIL8;
    ////////////property  logo : LongBlob Read Flogo Write Flogo;
    property  autocanceldieselorders : boolean Read Fautocanceldieselorders write Fautocanceldieselorders;
    property  autocanceldieselordersdays : Integer Read Fautocanceldieselordersdays Write Fautocanceldieselordersdays;
    property  sendloadconsprocess : Boolean Read  fsendloadconsprocess Write Fsendloadconsprocess;
    property   loadcoscutoffdate : Boolean Read Floadcoscutoffdate Write Floadcoscutoffdate;
    property  dieselcutoffdate : Boolean Read Fdieselcutoffdate Write Fdieselcutoffdate;
    property  hidecanceloadsplanning : Boolean Read Fhidecanceloadsplanning Write Fhidecanceloadsplanning;
    property  incrementdocketno : Boolean Read Fincrementdocketno Write Fincrementdocketno;
    property  linklastdriver : Boolean Read Fincrementdocketno Write Fincrementdocketno;
    property  planningshortdesc : Boolean Read Fplanningshortdesc Write Fplanningshortdesc;
    property  allowreprint : Boolean Read Fallowreprint Write Fallowreprint;
    property  removesubinvdocs : boolean read Fremovesubinvdocs Write Fremovesubinvdocs;
    property  loadsmustreceived : boolean Read Floadsmustreceived write Floadsmustreceived;
    property  fnbcontractid : String Read Ffnbcontractid Write Ffnbcontractid;
    property  fnbclientid : String Read Ffnbclientid Write Ffnbclientid;
    property  fnbdeblistcount : Integer Read Ffnbdeblistcount Write Ffnbdeblistcount;
    property  fnbcredlistcount : Integer Read Ffnbcredlistcount Write Ffnbcredlistcount;
    property  fnblastdebdate : Tdate Read Ffnblastdebdate Write Ffnblastdebdate;
    property  fnblastcreddate : TDate Read Ffnblastcreddate Write Ffnblastcreddate;
    property  fnblastdebamount : Real Read Ffnblastdebamount Write Ffnblastdebamount;
    property  fnblastcredamount : Real Read Ffnblastcredamount Write Ffnblastcredamount;
    property  fnbclienttype : Integer Read Ffnbclienttype Write Ffnbclienttype;
    property  linkloadsvat : Boolean Read Flinkloadsvat Write Flinkloadsvat;
    property  markmultiloadready : Boolean Read Fmarkmultiloadready Write Fmarkmultiloadready;
    property  bulkdieselinvoices : Boolean Read Fbulkdieselinvoices Write Fbulkdieselinvoices;
    property  clearbulkinvoices : Boolean Read Fclearbulkinvoices Write Fclearbulkinvoices;
    property  getsageonlinebalance : Boolean Read Fgetsageonlinebalance Write Fgetsageonlinebalance;
    property  usesageonlinebalancefordiesel : Real Read Fusesageonlinebalancefordiesel Write Fusesageonlinebalancefordiesel;
    property  apiserverurl : String Read Fapiserverurl Write Fapiserverurl;
    property  apiusername : String Read Fapiusername Write Fapiusername;
    property  apipassword : String Read Fapipassword Write Fapipassword;
    property  apikey : String Read Fapikey Write Fapikey;
    property  fuelconsumptionfullfills : Boolean Read Ffuelconsumptionfullfill Write Ffuelconsumptionfullfill;
    property  usenewscan : Boolean Read Fusenewscan Write Fusenewscan;
    property  basescanfolder : String Read Fbasescanfolder Write Fbasescanfolder;
    property  ftpserver : String Read Fftpserver Write Fftpserver;
    property  ftpport : SmallInt Read Fftpport Write Fftpport;
    property  ftpuser : String Read Fftpuser Write Fftpuser;
    property  ftppassword : String Read Fftppassword Write Fftppassword;
    property  multicontroller : Boolean Read Fmulticontroller Write Fmulticontroller;
    property  lastshiftno : Integer Read Flastshiftno Write Flastshiftno;
    property  dieselnonretail : Boolean Read Fdieselnonretail Write Fdieselnonretail;
    property  emailaddress : String Read Femailaddress Write Femailaddress;
    property  jobnullqty : boolean Read Fjobnullqty Write Fjobnullqty;
    property  joborder : boolean Read Fjoborder Write Fjoborder;
    property  jobcardtype : String Read Fjobcardtype Write Fjobcardtype;
    property  maintforcegl : Boolean Read Fmaintforcegl Write Fmaintforcegl;
    property  compemail : String Read Fcompemail Write Fcompemail;
    property  errormails : String Read Ferrormails Write Ferrormails;
  end;

  Tinvoicenumbers = class
    private
      FTranType ,
      FPrefix ,
      FDescription : String;
      FSuffix : integer;
    published
      property TranType : String Read FTranType Write FTranType;
      property Prefix : String Read FPrefix Write FPrefix;
      property Description : String Read FDescription Write FDescription;
      property Suffix : Integer Read FSuffix Write FSuffix;

  end;

  Tvattable = class
      private
        FVATPERC : Real;
        FSTARTDATE : TDate;
        FENDATE : TDate;
        FAuto : Integer;
      published
        property VATPERC : Real Read FVATPERC Write FVATPERC;
        property STARTDATE : TDate Read FSTARTDATE Write FSTARTDATE;
        property ENDATE : Tdate Read FENDATE Write FENDATE;
        property autono : integer Read FAuto Write FAuto;
  end;

  TGLCodes = class
    private
      FGLCODE : String;
      FGLDESCRIPTION : String;
      FSUSPENDED,
      Fbankaccount,
      Fbankcard : Boolean;
    published
      property GLCODE : String read FGLCODE write FGLCODE;
      property GLDESCRIPTION : String read FGLDESCRIPTION write FGLDESCRIPTION;
      property SUSPENDED : Boolean read FSUSPENDED write FSUSPENDED;
      property bankaccount : Boolean read Fbankaccount write Fbankaccount;
      property bankcard : Boolean read Fbankcard write Fbankcard;

  end;

  TCompanyGL = class
    private
      FGLDESCRIPTION : String;
      FFleetDesc : String;
      FValueTypesDesc : string;
      FSystemDesc : String;
      FGLCode : String;
      Fcompanygldetail_Auto : Integer;

    published
      property GLDESCRIPTION : String read FGLDESCRIPTION write FGLDESCRIPTION;
      property FleetDesc : String read FFleetDesc write FFleetDesc;
      property ValueTypesDesc : String read FValueTypesDesc write FValueTypesDesc;
      property SystemDesc : String read FSystemDesc write FSystemDesc;
      property GLCode : String Read FGLCode Write FGLCode;
      property Companygldetail_Auto : Integer Read Fcompanygldetail_Auto Write Fcompanygldetail_Auto;

  end;

  TFinSystems = class
    private
      FFINNO : Integer;
      FFINNAME : String;
      FFINACTIVE : Boolean;

    published
      property FINNO : Integer read FFINNO write FFINNO;
      property FINNAME : String read FFINNAME write FFINNAME;
      property FINACTIVE : Boolean read FFINACTIVE write FFINACTIVE;

  end;

  TTFNSubAccounts = class
    private
      FApiServerNo : Integer;
      FSubContractNo : String;
      FApiAccountNo : String;
      FLastRunDate : TDateTime;
      FSubsRegNo : String;
      FCRName : String;
    published
      property apiserverno : Integer read FApiServerNo write FApiServerNo;
      property subcontractorno : String read FSubContractNo write FSubContractNo;
      property apiaccountno : String read FApiAccountNo write FApiAccountNo;
      property lastrundate : TDateTime read FLastRunDate write FLastRunDate;
      property subsregno : String read FSubsRegNo write FSubsRegNo;
      property CRNAME : String read FCRName write FCRName;
  end;

  TCompGLDetailsIndexes = class
    private
      Ffleettype,
      Fvaluetype,
      Fsystemtype,
      Fcompanygldetail_Auto : Integer;
      Fglcode : String;

    published
      property fleettype : Integer Read Ffleettype Write Ffleettype;
      property valuetype : Integer Read Fvaluetype Write Fvaluetype;
      property systemtype : Integer Read Fsystemtype Write Fsystemtype;
      property glcode : String Read Fglcode Write Fglcode;
      property companygldetail_Auto : Integer Read Fcompanygldetail_Auto Write Fcompanygldetail_Auto;

  end;

  TFinLinkSystem  = class
    private
      FFinNo : Integer;
      FFinName : String;
      FFinActive : String;

    published
      property FINNO : Integer Read FFinNo Write FFinNo;
      property FINNAME : String Read FFinName Write FFinName;
      property FINACTIVE : String Read FFinActive Write FFinActive;

  end;

implementation

end.
